export class TableButton {
    label?: string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    handler?: (item) => void;
    route?: string;

    style?: 'btn-primary' | 'btn-secondary';

    /**
     * Provide an icon name to show an icon.
     * Must be present in assets/images/icons/<icon>.svg
     * whereas 'icon' is the name you provide
     */
    icon: string;

    /**
     * If set to true, shows the icon only.
     * ATTENTION: Currently only implemented for buttons in the dropdown submenu.
     */
    showIconOnly?: boolean = false;

    /**
     * If set to true, button will be hidden behind the "3 dots" dropdown
     */
    putInDropdownSubmenu?: boolean = false;

    isDisabled?: boolean = false;

    uitAttribute?: string;

    get isPrimary(): boolean {
        return this.style === 'btn-primary';
    }

    get isSecondary(): boolean {
        return this.style === 'btn-secondary';
    }

    constructor(obj?: Partial<TableButton>) {
        Object.assign(this, obj);
    }
}
